export default __webpack_public_path__ + "27b79ec.png";